module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('div', {
    staticClass: "m-b-20 m-r-10 fr"
  }, [_c('el-button', {
    staticClass: "m-r-10",
    attrs: {
      "type": _vm.primary
    },
    on: {
      "click": function($event) {
        _vm.reloadIframe()
      }
    }
  }, [_vm._v("\n      刷新\n    ")]), _vm._v(" "), (_vm.canOpen) ? _c('el-button', {
    staticClass: "m-r-10",
    attrs: {
      "type": _vm.primary
    },
    on: {
      "click": function($event) {
        _vm.newOpenIframe()
      }
    }
  }, [_vm._v("\n      新窗口打开\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "m-b-20 m-r-10 fl msg"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "iframeContent"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e08670b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/iframeRender.vue
// module id = 1809
// module chunks = 2